import { ReactComponent as HomeIcon } from './iocnSVG/home.svg'
import { ReactComponent as UserIcon } from './iocnSVG/user.svg'
import { ReactComponent as LostIcon } from './iocnSVG/lost.svg'
import { ReactComponent as LogoIcon } from './iocnSVG/logo.svg'
import { ReactComponent as PoolsIcon } from './iocnSVG/pools.svg'
import { ReactComponent as SwapIcon } from './iocnSVG/swap.svg'
import { ReactComponent as LinkIcon } from './iocnSVG/link.svg'
import { ReactComponent as ShareIcon } from './iocnSVG/share.svg'

const paths = {
    home: HomeIcon,
    user: UserIcon,
    lost: LostIcon,
    pools: PoolsIcon,
    logo: LogoIcon,
    swap: SwapIcon,
    link: LinkIcon,
    share: ShareIcon
}
function MyIcon({i = 'home' ,...props}) {
  const Path = paths[i] || LostIcon
  return (
    <Path {...props}/>
  );
}

export default MyIcon
